import "./FAQ.css"
import {useTitle} from "../useTitle";

function FAQ() {
  useTitle('FAQ');

  return (
    <div className={"faq"}>
      <h2>FAQ</h2>
      <dl>
        <dt>Q: How often does this webcomic update</dt>
        <dd>A: Monday, wednesday, friday.</dd>
      </dl>
    </div>
  );
}

export default FAQ;